import React from 'react';
import { FcGoogle } from 'react-icons/fc';
import { FaFacebookF, FaApple, FaEnvelope } from 'react-icons/fa';

const SocialLoginButtons = () => {
  return (
    <>
      <div className="social-divider">
        <span>or continue with</span>
      </div>
      
      <div className="social-login-row">
        <button type="button" className="social-btn native-btn"><FcGoogle size={20} /></button>
        <button type="button" className="social-btn native-btn"><FaFacebookF size={18} color="#1877f2" /></button>
        <button type="button" className="social-btn native-btn"><FaApple size={20} color="#fff" /></button>
        <button type="button" className="social-btn native-btn"><FaEnvelope size={18} color="#a0a0a0" /></button>
      </div>
    </>
  );
};

export default SocialLoginButtons;
